import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { AmendmentList } from "./AmendmentList";
import {
  type AmendmentListDataProps,
  amendmentListDataSchema,
} from "./AmendmentList.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "amendment-list": {
      props: AmendmentListDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-amendment-list": HTMLElement;
  }
}

export function RWCAmendmentList({ year }: AmendmentListDataProps): JSX.Element {
  return <AmendmentList year={year} />;
}

componentManager.register(
  rwc("amendment-list", {
    component: RWCAmendmentList,
    dataSchema: amendmentListDataSchema,
  }),
);
